import { useLocalStorageState } from './useLocalStorageState';

const STORAGE_KEY = 'matchiGridMixedOnly';
const DEFAULT_VALUE = false;

export const useMixedOnly = () => {
	const [mixedOnly, setMixedOnly] = useLocalStorageState(STORAGE_KEY, DEFAULT_VALUE);
	return { mixedOnly, setMixedOnly };
};
